import type { ViewComponent } from "@frui.ts/views";
import type ChargeDetailInfoViewModel from "viewModels/callCenter/search/charges/chargeDetail/chargeDetailInfoViewModel";
import { observer } from "mobx-react-lite";
import ChargeDetailSection from "./chargeDetailSection";
import { Col, Form, Row } from "react-bootstrap";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { formatAmount, formatDateTime } from "utils/localizations";
import { chargeDisplayStatusToVariant } from "entities/chargeDisplayStatus";
import React from "react";
import { vehicleRegisterSynchronizationStatusToVariant } from "entities/vehicleRegisterSynchronizationStatus";
import { FormLabelWithTooltip } from "controls/formLabelWithTooltip";
import { emptyValue } from "utils/emptyValue";

const ChargeDetailChargeSection: ViewComponent<ChargeDetailInfoViewModel> = observer(({ vm }) => {
  return (
    <ChargeDetailSection title={vm.translate("chargeDetail")}>
      <Row>
        <Form.Group as={Col} md={6} xl={4}>
          <Form.Label>{vm.translateSubAttribute("singleChargeDetailResponse", "countryId")}</Form.Label>
          <FakeInput target={vm.item.chargeDetail} property="countryId" valueFormatter={value => vm.translateCountryId(value)} />
        </Form.Group>
        <Form.Group as={Col} md={6} xl={4}>
          <Form.Label>{vm.translateSubAttribute("singleChargeDetailResponse", "licensePlate")}</Form.Label>
          <FakeInput target={vm.item.chargeDetail} property="licensePlate" />
        </Form.Group>
        <Form.Group as={Col} md={6} xl={4}>
          <Form.Label>{vm.translateSubAttribute("singleChargeDetailResponse", "_chargeTypeId")}</Form.Label>
          <FakeInput target={vm.item.chargeDetail} property="_chargeTypeId" valueFormatter={value => vm.translateChargeType()} />
        </Form.Group>
        <Form.Group as={Col} md={6} xl={8}>
          <Form.Label>{vm.translateSubAttribute("singleChargeDetailResponse", "_fuelTypeId")}</Form.Label>
          <FakeInput target={vm.item.chargeDetail} property="_fuelTypeId" valueFormatter={value => vm.translateFuelType()} />
        </Form.Group>
        <Form.Group as={Col} md={6} xl={4}>
          <Form.Label>{vm.translateSubAttribute("singleChargeDetailResponse", "chargeDisplayStatus")}</Form.Label>
          <FakeInput
            target={vm.item.chargeDetail}
            property="chargeDisplayStatus"
            valueFormatter={value => {
              const formattedValue = vm.translateChargeDisplayStatus(value);
              return <strong className={`text-${chargeDisplayStatusToVariant(value)}`}>{formattedValue}</strong>;
            }}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} xl={4}>
          <Form.Label>{vm.translateSubAttribute("singleChargeDetailResponse", "price")}</Form.Label>
          <FakeInput target={vm.item.chargeDetail} property="price" valueFormatter={value => formatAmount(value)} />
        </Form.Group>
        <Form.Group as={Col} md={6} xl={8}>
          <Form.Label>{vm.translateSubAttribute("singleChargeDetailResponse", "emailAddress")}</Form.Label>
          <FakeInput target={vm.item.chargeDetail} property="emailAddress" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("singleChargeDetailResponse", "validSince")}</Form.Label>
          <FakeInput target={vm.item.chargeDetail} property="validSince" valueFormatter={value => formatDateTime(value)} />
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("singleChargeDetailResponse", "validUntil")}</Form.Label>
          <FakeInput target={vm.item.chargeDetail} property="validUntil" valueFormatter={value => formatDateTime(value)} />
        </Form.Group>
        <Form.Group as={Col} md={6} xl={12}>
          <Form.Label>{vm.translateSubAttribute("singleChargeDetailResponse", "id")}</Form.Label>
          <FakeInput target={vm.item.chargeDetail} property="id" />
        </Form.Group>
        <Form.Group as={Col} md={6} xl={12}>
          <Form.Label></Form.Label>
          <FormLabelWithTooltip tooltipText={vm.translate("vehicleRegisterSynchronizationStatusTooltip")}>
            {vm.translateSubAttribute("singleChargeDetailResponse", "vehicleRegisterSynchronizationStatus")}
          </FormLabelWithTooltip>
          <FakeInput
            target={vm.item.chargeDetail}
            property="vehicleRegisterSynchronizationStatus"
            valueFormatter={value => {
              const formattedValue = vm.translateVehicleRegisterSynchronizationStatus(value);
              return <strong className={`text-${vehicleRegisterSynchronizationStatusToVariant(value)}`}>{formattedValue}</strong>;
            }}
          />
        </Form.Group>
      </Row>
    </ChargeDetailSection>
  );
});

export default ChargeDetailChargeSection;
